module.exports = __webpack_public_path__ + "skeleton.jpg?bbec873aad40f6eff197899778d4c0df";